import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_need_matched_personalization~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_need_matched_personalization'
					),
			},
		},
	},
]

export default config
